import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import type { ITheme } from '@homeviews/styles'
import { EditProfileForm } from '@homeviews/auth'
import { WindowTitle } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
  }),
)
const UserProfile: React.FC = () => {
  const classes = useStyles()
  return (
    <>
      <WindowTitle title="User Profile" />
      <div className={classes.root}>
        <EditProfileForm />
      </div>
    </>
  )
}

export default UserProfile
